/** Демо-сценарии лендинга. Позже заменяются данными реальных анализов администратора.
 *  Поля таблицы и модалки (критерии, товары, риски, roadmap, чат) — в demoTenderRows.js. */
export const LANDING_DEMO_SCENARIOS = [
  {
    id: 'events',
    label: 'Организация мероприятий',
    icon: 'calendar',
    metrics: { found: 94, relevant: 28, volume: 41200000, relevance: 78 },
    steps: [
      { id: 'platforms', label: 'Подключены площадки', status: 'done' },
      { id: 'search', label: 'Поиск тендеров', status: 'done' },
      { id: 'requirements', label: 'Анализ требований', status: 'done' },
      { id: 'risks', label: 'Оценка рисков', status: 'running' },
      { id: 'results', label: 'Формирование результатов', status: 'pending' },
    ],
    progress: 68,
    tenders: [
      {
        law: '44-ФЗ',
        relevance: 'high',
        title: 'Организация и проведение городского форума',
        customer: 'Комитет по развитию туризма г. Казани',
        price: 18500000,
        deadline: '2026-06-18',
        tags: ['Мероприятия', 'Площадка', 'Кейтеринг'],
        risk: 'Короткий срок подготовки',
        riskLevel: 'medium',
      },
      {
        law: '223-ФЗ',
        relevance: 'high',
        title: 'Техническое обеспечение конференции',
        customer: 'ПАО «РегионМедиа»',
        price: 9200000,
        deadline: '2026-06-22',
        tags: ['Звук', 'Свет', 'Сцена'],
        risk: 'Требуется опыт аналогичных контрактов',
        riskLevel: 'low',
      },
      {
        law: '44-ФЗ',
        relevance: 'medium',
        title: 'Поставка мебели для зала мероприятий',
        customer: 'ГБУ «Дворец культуры»',
        price: 4300000,
        deadline: '2026-07-01',
        tags: ['Мебель', 'Монтаж'],
        risk: 'Жёсткие сроки поставки',
        riskLevel: 'medium',
      },
    ],
    lockedCount: 25,
  },
  {
    id: 'pumps',
    label: 'Насосное оборудование',
    icon: 'pump',
    metrics: { found: 118, relevant: 31, volume: 62400000, relevance: 84 },
    steps: [
      { id: 'platforms', label: 'Подключены площадки', status: 'done' },
      { id: 'search', label: 'Поиск тендеров', status: 'done' },
      { id: 'requirements', label: 'Анализ требований', status: 'done' },
      { id: 'risks', label: 'Оценка рисков', status: 'done' },
      { id: 'results', label: 'Формирование результатов', status: 'running' },
    ],
    progress: 88,
    tenders: [
      {
        law: '223-ФЗ',
        relevance: 'high',
        title: 'Поставка промышленных насосов для водоснабжения',
        customer: 'АО «РегионТехСнаб»',
        price: 32400000,
        deadline: '2026-06-25',
        tags: ['Насосы', 'Запчасти'],
        risk: 'Расширенная гарантия и складской запас',
        riskLevel: 'medium',
      },
      {
        law: '44-ФЗ',
        relevance: 'high',
        title: 'Ремонт насосного оборудования котельной',
        customer: 'МУП «Теплосеть»',
        price: 8700000,
        deadline: '2026-06-30',
        tags: ['Сервис', 'Котельная'],
        risk: 'Требуется допуск СРО',
        riskLevel: 'high',
      },
      {
        law: '44-ФЗ',
        relevance: 'medium',
        title: 'Закупка циркуляционных насосов',
        customer: 'ГБУ «Жилфонд»',
        price: 2100000,
        deadline: '2026-07-05',
        tags: ['Насосы', 'ЖКХ'],
        risk: 'Низкая начальная цена',
        riskLevel: 'low',
      },
    ],
    lockedCount: 28,
  },
  {
    id: 'servers',
    label: 'Серверное оборудование',
    icon: 'server',
    metrics: { found: 76, relevant: 19, volume: 95800000, relevance: 86 },
    steps: [
      { id: 'platforms', label: 'Подключены площадки', status: 'done' },
      { id: 'search', label: 'Поиск тендеров', status: 'done' },
      { id: 'requirements', label: 'Анализ требований', status: 'done' },
      { id: 'risks', label: 'Оценка рисков', status: 'running' },
      { id: 'results', label: 'Формирование результатов', status: 'pending' },
    ],
    progress: 72,
    tenders: [
      {
        law: '44-ФЗ',
        relevance: 'high',
        title: 'Поставка серверного оборудования для дата-центра',
        customer: 'ГУП «Инфосеть»',
        price: 48900000,
        deadline: '2026-07-02',
        tags: ['Серверы', 'СХД', 'ИБП'],
        risk: 'Интеграционный опыт и SLA',
        riskLevel: 'medium',
      },
      {
        law: '223-ФЗ',
        relevance: 'high',
        title: 'Модернизация серверной инфраструктуры',
        customer: 'АО «ФинТех Групп»',
        price: 22100000,
        deadline: '2026-06-28',
        tags: ['Серверы', 'Сеть'],
        risk: 'Поэтапная приёмка',
        riskLevel: 'low',
      },
      {
        law: '44-ФЗ',
        relevance: 'medium',
        title: 'Закупка систем хранения данных',
        customer: 'Минцифры региона',
        price: 15600000,
        deadline: '2026-07-10',
        tags: ['СХД', 'Резервирование'],
        risk: 'Импортозамещение',
        riskLevel: 'medium',
      },
    ],
    lockedCount: 16,
  },
  {
    id: 'cleaning',
    label: 'Клининговые услуги',
    icon: 'clean',
    metrics: { found: 162, relevant: 42, volume: 87650000, relevance: 81 },
    steps: [
      { id: 'platforms', label: 'Подключены площадки', status: 'done' },
      { id: 'search', label: 'Поиск тендеров', status: 'done' },
      { id: 'requirements', label: 'Анализ требований', status: 'done' },
      { id: 'risks', label: 'Оценка рисков', status: 'running' },
      { id: 'results', label: 'Формирование результатов', status: 'pending' },
    ],
    progress: 72,
    tenders: [
      {
        law: '44-ФЗ',
        relevance: 'high',
        title: 'Уборка офисных помещений администрации',
        customer: 'Администрация г. Казани',
        price: 4200000,
        deadline: '2026-06-20',
        tags: ['Клининг', 'Персонал'],
        risk: 'Короткий срок исполнения',
        riskLevel: 'medium',
      },
      {
        law: '223-ФЗ',
        relevance: 'high',
        title: 'Комплексная уборка производственных помещений',
        customer: 'АО «ПромКомплекс»',
        price: 9800000,
        deadline: '2026-06-27',
        tags: ['Клининг', 'Промышленность'],
        risk: 'Требуется медкнижки персонала',
        riskLevel: 'low',
      },
      {
        law: '44-ФЗ',
        relevance: 'high',
        title: 'Уборка и содержание прилегающих территорий',
        customer: 'ГБУ «Жилкомсервис»',
        price: 3100000,
        deadline: '2026-07-03',
        tags: ['Уборка', 'Территория'],
        risk: 'Сезонная нагрузка',
        riskLevel: 'low',
      },
    ],
    lockedCount: 39,
  },
  {
    id: 'construction',
    label: 'Строительно-монтажные работы',
    icon: 'build',
    metrics: { found: 203, relevant: 47, volume: 142300000, relevance: 79 },
    steps: [
      { id: 'platforms', label: 'Подключены площадки', status: 'done' },
      { id: 'search', label: 'Поиск тендеров', status: 'done' },
      { id: 'requirements', label: 'Анализ требований', status: 'done' },
      { id: 'risks', label: 'Оценка рисков', status: 'running' },
      { id: 'results', label: 'Формирование результатов', status: 'pending' },
    ],
    progress: 74,
    tenders: [
      {
        law: '44-ФЗ',
        relevance: 'high',
        title: 'Капитальный ремонт административного здания',
        customer: 'Минстрой региона',
        price: 38500000,
        deadline: '2026-08-01',
        tags: ['Ремонт', 'СМР'],
        risk: 'Длительный срок и обеспечение',
        riskLevel: 'high',
      },
      {
        law: '223-ФЗ',
        relevance: 'medium',
        title: 'Монтаж инженерных систем',
        customer: 'ООО «СтройИнвест»',
        price: 12400000,
        deadline: '2026-07-15',
        tags: ['Монтаж', 'Инженерия'],
        risk: 'Субподряд запрещён',
        riskLevel: 'medium',
      },
      {
        law: '44-ФЗ',
        relevance: 'high',
        title: 'Благоустройство придомовой территории',
        customer: 'Администрация района',
        price: 6800000,
        deadline: '2026-06-24',
        tags: ['Благоустройство'],
        risk: 'Погодные ограничения',
        riskLevel: 'low',
      },
    ],
    lockedCount: 44,
  },
  {
    id: 'medical',
    label: 'Медоборудование',
    icon: 'medical',
    metrics: { found: 88, relevant: 24, volume: 71300000, relevance: 87 },
    steps: [
      { id: 'platforms', label: 'Подключены площадки', status: 'done' },
      { id: 'search', label: 'Поиск тендеров', status: 'done' },
      { id: 'requirements', label: 'Анализ требований', status: 'done' },
      { id: 'risks', label: 'Оценка рисков', status: 'done' },
      { id: 'results', label: 'Формирование результатов', status: 'running' },
    ],
    progress: 90,
    tenders: [
      {
        law: '44-ФЗ',
        relevance: 'high',
        title: 'Поставка дефibrилляторов и мониторов',
        customer: 'ГБУЗ «Городская больница №3»',
        price: 14200000,
        deadline: '2026-06-29',
        tags: ['Медтехника', 'Реанимация'],
        risk: 'Регистрационное удостоверение Росздравнадзора',
        riskLevel: 'medium',
      },
      {
        law: '223-ФЗ',
        relevance: 'high',
        title: 'Закупка медицинской мебели',
        customer: 'АО «МедСервис»',
        price: 5600000,
        deadline: '2026-07-08',
        tags: ['Мебель', 'Клиника'],
        risk: 'Сертификация продукции',
        riskLevel: 'low',
      },
      {
        law: '44-ФЗ',
        relevance: 'medium',
        title: 'Поставка расходных материалов для лаборатории',
        customer: 'ФБУ «Региональный центр»',
        price: 2800000,
        deadline: '2026-07-12',
        tags: ['Расходники', 'Лаборатория'],
        risk: 'Единственный поставщик по ТЗ',
        riskLevel: 'high',
      },
    ],
    lockedCount: 21,
  },
]

export function formatRub(value) {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0,
  }).format(value)
}

export function formatVolume(value) {
  if (value >= 1_000_000) {
    return `${Math.round(value / 1_000_000).toLocaleString('ru-RU')} млн ₽`
  }
  return formatRub(value)
}

export function formatDate(iso) {
  try {
    return new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long' }).format(new Date(iso))
  } catch {
    return iso
  }
}
